import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable, NgZone} from '@angular/core';
import {
  AddSelection, CancelEditSelection,
  DeleteSelection, EditSelection,
  FetchSelections, UpdateSelection,
  FetchFiltered
} from './selections.actions';
import {SelectionsService} from '../services/selections.service';
import {tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {patch, removeItem, updateItem, insertItem} from '@ngxs/store/operators';
import {Selection, SelectionOrNull} from "../models";
import {HistoryService} from "../../history/services/history.service";
import {Router} from "@angular/router";


export class SelectionsStateModel {
  public items: Selection[];
  public loading: boolean;
  public dataLoaded: boolean;
  public editSelection: SelectionOrNull;
  public openSidebar: boolean;
  public filtered: any[];
}


@State<SelectionsStateModel>({
  name: 'selections',
  defaults: {
    items: [],
    loading: false,
    dataLoaded: false,
    editSelection: null,
    openSidebar: false,
    filtered: [],
  }
})
@Injectable()
export class SelectionsState {

  @Action(FetchSelections)
  fetch(ctx: StateContext<SelectionsStateModel>, action: FetchSelections) {
    ctx.patchState({loading: true});

    return this.selectionsService.fetchSelections().pipe(
      tap((response: any) => {

        ctx.patchState({
          items: response.results as Selection[],
          loading: false,
          dataLoaded: true
        });
      })
    );
  }

  @Action(FetchFiltered)
  fetchFiltered(ctx: StateContext<SelectionsStateModel>, action: FetchFiltered) {
    if(action.payload.filters.filter(x => x.type || x.val).length == 0) {
        ctx.patchState({
          filtered: [],
        });
    } else {
      return this.selectionsService.fetchFiltered(action.payload).pipe(
        tap((response: any) => {
          ctx.patchState({
            filtered: response,
          });
        })
      );
    }
  }

  @Action(AddSelection)
  addSelection(ctx: StateContext<SelectionsStateModel>, action: AddSelection) {
    return this.selectionsService.addSelection(action.payload).pipe(
      tap((response: any) => {
        ctx.setState(
          patch({
            items: insertItem(response as Selection, 0),
            editSelection: response as Selection,
          })
        );

        this.ngZone.run(() => {
          this.snackBar.open('Добавлено');
        });
        this.historyService.addAction({
          'text': `добавил выборку "${response.title}"`,
          'model': 'selection',
          'operation': 'create',
          'object_id': response.id
        })
      })
    );
  }

  @Action(UpdateSelection)
  updateSelection(ctx: StateContext<SelectionsStateModel>, action: UpdateSelection) {
    return this.selectionsService.updateSelection(action.payload.id, action.payload).pipe(
      tap((response: any) => {
        let state = ctx.getState();
        let index = null;
        for(let i =0 ; i < state.items.length ; i++) {
          if(state.items[i].id == response.id) {
            index = i;
            break;
          }
        }
        if(index !== null) {
          ctx.setState(
            patch({
              items: updateItem(index, response),
              editSelection: response as Selection,
            })
          );

        }
        this.ngZone.run(() => {
          this.snackBar.open('Сохранено');
        });
        this.historyService.addAction({
          'text': `обновил выборку "${response.title}"`,
          'model': 'selection',
          'operation': 'update',
          'object_id': response.id
        })
      })
    );
  }

  @Action(DeleteSelection)
  deleteSelection(ctx: StateContext<SelectionsStateModel>, action: DeleteSelection) {

    const state = ctx.getState();

    return this.selectionsService.deleteSelection(action.selection.id).pipe(
      tap((response) => {

        ctx.setState(
          patch({
            items: removeItem((i: any) => i.id === action.selection.id),
          })
        );

        this.historyService.addAction({
          'text': `удалил выборку "${action.selection.title}"`,
          'model': 'selection',
          'operation': 'delete',
          'object_id': action.selection.id
        })

      })
    );
  }

  @Action(EditSelection)
  editSelection(ctx: StateContext<SelectionsStateModel>, action: EditSelection) {
    const state = ctx.getState();
    this.router.navigate(['selections'], {queryParams: {id: action.payload.id}});
    ctx.patchState({
      editSelection: action.payload,
      openSidebar: true,
    });

  }

  @Action(CancelEditSelection)
  cancelEditWidget(ctx: StateContext<SelectionsStateModel>, action: CancelEditSelection) {
    const state = ctx.getState();

    this.router.navigate(['selections']);
    ctx.patchState({
      editSelection: null,
      openSidebar: false,
    });
  }

  constructor(private selectionsService: SelectionsService,
              private historyService: HistoryService,
              private ngZone: NgZone,
              private snackBar: MatSnackBar,
              private router: Router,
              private store: Store) {
  }

}
